import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import {
    ListItem,
    ListItemText,
} from "@mui/material";
import Skeleton from '@mui/material/Skeleton';

const ControlledSkelton = (props) => {

    const { hideAvatar, hideSecondary, lengthArray = [1, 2, 3] } = props;

    return (
        <Fragment>
            {
                (lengthArray || [1, 2, 3]).map((dt) => {
                    return (
                        <Fragment key={dt}>
                            <ListItem
                                style={{ paddingTop: 0 }}
                                alignItems="flex-start"
                            >
                                {hideAvatar ? "" : <Skeleton width={50} height={50} variant="circular" />}
                                <ListItemText
                                    primary={
                                        <Fragment>
                                            <Skeleton />
                                        </Fragment>
                                    }
                                    secondary={
                                        hideSecondary ? "" :
                                            <Fragment>
                                                <Skeleton width={"50%"} />
                                            </Fragment>
                                    }
                                />
                            </ListItem>
                        </Fragment>
                    );
                })
            }
        </Fragment>
    );
}
ControlledSkelton.propTypes = {
    hideSecondary: PropTypes.bool,
    hideAvatar: PropTypes.bool,
    lengthArray: PropTypes.array
}

ControlledSkelton.defaultProps = {
    hideSecondary: false,
    hideAvatar: false,
    lengthArray: [1, 2, 3]
}

export default ControlledSkelton;